/************************************************************
 * Align enum for anchor and childAnchor
 ***********************************************************/
/**Anchor enum */
export enum Anchor{
    top = 'top',
    topLeft = 'topLeft',
    topRight = 'topRight',
    bottom = 'bottom',
    bottomLeft = 'bottomLeft',
    bottomRight = 'bottomRight',
    left = 'left',
    right = 'right',
    center = 'center',
}
